import { Component, OnInit } from '@angular/core';
import { CustomText } from 'projects/shared/lib/components/shared/custom-text/custom-text.model';
import { ECustomTextType } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { WidgetBaseComponent } from '../../widget-base/widget-base.component';

import { CustomTextComponent } from '../../../custom-text/custom-text.component';

@Component({
    selector: 'app-widget-web-text-base',
    imports: [CustomTextComponent],
    templateUrl: './widget-web-text.component.html',
    styleUrls: ['./widget-web-text-base.component.scss']
})
export class WidgetWebTextBaseComponent extends WidgetBaseComponent implements OnInit {
  public customText: CustomText | undefined;

  public ngOnInit(): void {
    let group = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Group") == 0)?.value;
    let name = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Name") == 0)?.value;
    let type = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Type") == 0)?.value;

    if (group == undefined || name == undefined || type == undefined) {
      return;
    }

    this.customText = new CustomText((<any>ECustomTextType)[type], group, name);
  }
}
